export default __webpack_public_path__ + "static/media/caret-left.f44a9412.svg";